import * as React from 'react'
import { Alert, Form, Button, Spin } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import autobind from 'autobind-decorator'
import { withTranslation, WithTranslation } from 'react-i18next'
import { CommandResult } from 'src/core/stores/types'
import { formatMessage } from '../../services/http.service'
let FormItem = Form.Item

interface FormEditorViewProps extends FormComponentProps, WithTranslation {
  children: React.ReactChild,
  onSaveItem: (values: any) => Promise<any>
  style?: React.CSSProperties,
  hideMessage?: boolean
}

interface FormEditorViewState {
  isBusy: boolean,
  result: CommandResult<any>
}

class FormEditorView extends React.Component<FormEditorViewProps, FormEditorViewState> {
  constructor(props: FormEditorViewProps) {
    super(props)
    this.state = {
      isBusy: false,
      result: { isSuccess: true, items: [], messages: [] }
    }
  }

  @autobind
  private onSaveItem() {
    this.setState({ isBusy: true })
    var self = this
    return new Promise((resolve, reject) => {
      self.props.form.validateFields(event => {
        var values = self.props.form.getFieldsValue()
        if (!event) {
          return new Promise((resolve1, reject1) => {
            self.props.onSaveItem(values).then(res => {
              this.setState({ isBusy: false, result: res })
              self.props.form.resetFields()
              resolve(res)
            }).catch(error => {
              var parsedError = error && error.response && error.response.data && error.response.data.messages ? error.response.data : {
                isSuccess: false,
                items: [],
                total: 0,
                messages: [{ body: formatMessage(error), level: 'Error' }]
              }
              this.setState({ isBusy: false, result: parsedError })
              reject1(error)
            })
          })
        }
        else
          this.setState({ isBusy: false })

      })
    })
  }

  @autobind
  private onCancel() {
    this.props.form.resetFields()
    this.setState({ result: { isSuccess: true, items: [], messages: [] } })
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, (child: any) => React.cloneElement(child, this.props))
    const { resetFields, isFieldsTouched } = this.props.form
    const { t } = this.props as any

    return <Spin spinning={this.state.isBusy}>
      {this.state.result && !this.state.result.isSuccess && !this.props.hideMessage &&
        <Alert style={{ marginBottom: 16 }}
          type='error'
          message={t('An error occurred')}
          description={this.state.result.messages.map((o) => o.body)}
        />
      }
      <div style={this.props.style} onKeyUp={(e) => { if (e.keyCode === 13) { this.onSaveItem() } }}>
        {childrenWithProps}
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          {isFieldsTouched() && <div><Button type='primary' style={{ float: 'right' }} onClick={this.onSaveItem}>{t('Save')}</Button><Button type='default' style={{ float: 'right', marginRight: 10 }} onClick={this.onCancel}>{t('Cancel')}</Button></div>}
        </div>
      </div>
    </Spin>
  }
}

export default withTranslation()(FormEditorView)
